import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMedia } from 'react-use';
import cn from 'classnames';
import Heading from 'components/shared/heading';
import DesktopView from './DesktopView/index';
import MobileView from './MobileView/index';
import styles from './styles.module.scss';

const CenterImageFeatures = ({
  title = null,
  titleTag = 'h2',
  description = null,
  cards = [],
  theme = null,
}) => {
  const containerRef = useRef(null);

  // Desktop: >= 768px (shows split layout), Mobile: < 768px (shows accordion layout)
  // isClient guard ensures SSR and initial hydration always render DesktopView,
  // preventing React hydration mismatch error #418.
  const [isClient, setIsClient] = useState(false);
  const isDesktop = useMedia('(min-width: 768px)', true);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <section
      className={cn(styles.root, { [styles.themeLight]: theme === 'light' })}
      ref={containerRef}
    >
      <div className={styles.inner}>
        <div className="container">
          {title && (
            <Heading className={styles.title} tag={titleTag} size="xl">
              {title}
            </Heading>
          )}
          {description && (
            <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
          )}
          <div className={styles.content}>
            {!isClient || isDesktop ? <DesktopView cards={cards} /> : <MobileView cards={cards} />}
          </div>
        </div>
      </div>
    </section>
  );
};

CenterImageFeatures.propTypes = {
  title: PropTypes.string,
  titleTag: PropTypes.oneOf(['h1', 'h2', 'h3']),
  description: PropTypes.string,
  theme: PropTypes.oneOf(['light']),
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.shape({
        id: PropTypes.number,
        url: PropTypes.string,
        alt: PropTypes.string,
      }),
    })
  ),
};

export default CenterImageFeatures;
